export enum ErrorMessage {
    emptyNameError = 'Name Cannot be Empty',
    emptyAgeError = 'Age cannot be Empty',
    emptyGenderError = 'Please Select Any one of the gender',
    emptyPhoneNumberError = 'Phone Number cannot be empty',
    emptyBaseLocationError = 'Choose any one of the Base location',
    emptyDiagnosticCenterError = 'Choose any one of the Dianostic center',
    emptyPackageError = 'Package is required.',
    emptyTimeSlotError= 'Preferred time slot is required.'
}